import React from 'react';
import { toast } from 'react-toastify';

export const notifySuccess = (title) =>
  toast(title, {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    className: 'bg-success text-white',
    autoClose: 2000,
    pauseOnHover: true,
    style: {
      width: 400,
    },
  });

export const notifyError = (title) =>
  toast(title, {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    className: 'bg-danger text-white',
    autoClose: 2000,
    pauseOnHover: true,
    style: {
      whiteSpace: 'nowrap',
      width: '370px',
    },
  });

export const notifyWarning = (title) =>
  toast(title, {
    position: 'top-center',
    hideProgressBar: true,
    closeOnClick: false,
    className: 'bg-warning text-white',
    autoClose: 5000,
    pauseOnHover: true,
    style: {
      whiteSpace: 'nowrap',
      width: '370px',
    },
  });
